import { render, staticRenderFns } from "./TaskLabelDetachedActivity.vue?vue&type=template&id=3af4d855"
import script from "./TaskLabelDetachedActivity.vue?vue&type=script&lang=js"
export * from "./TaskLabelDetachedActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports